"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isZeroOrPositive;

/**
 * Returns `true`, if the number is zero or positive, otherwise, `false`, including minus zeroes.
 */
function isZeroOrPositive(value) {
  // This will handle minus-zero.
  return 1 / value >= 0;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc1plcm9PclBvc2l0aXZlIiwidmFsdWUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9pc1plcm9PclBvc2l0aXZlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogUmV0dXJucyBgdHJ1ZWAsIGlmIHRoZSBudW1iZXIgaXMgemVybyBvciBwb3NpdGl2ZSwgb3RoZXJ3aXNlLCBgZmFsc2VgLCBpbmNsdWRpbmcgbWludXMgemVyb2VzLlxuICovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBpc1plcm9PclBvc2l0aXZlKHZhbHVlOiBudW1iZXIpOiBib29sZWFuIHtcbiAgLy8gVGhpcyB3aWxsIGhhbmRsZSBtaW51cy16ZXJvLlxuICByZXR1cm4gMSAvIHZhbHVlID49IDA7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUNBO0FBQ0E7QUFDZSxTQUFTQSxnQkFBVCxDQUEwQkMsS0FBMUIsRUFBa0Q7RUFDL0Q7RUFDQSxPQUFPLElBQUlBLEtBQUosSUFBYSxDQUFwQjtBQUNEIn0=